"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HlUserOnboardingRejectionInfo = exports.HlOnboardingRejectionReason = void 0;
const BaseUserOnboardingRejectionInfo_1 = require("../../common/domain/BaseUserOnboardingRejectionInfo");
var HlOnboardingRejectionReason;
(function (HlOnboardingRejectionReason) {
    HlOnboardingRejectionReason["ZONE_NOT_SUPPORTED_YET"] = "ZONE_NOT_SUPPORTED_YET";
    HlOnboardingRejectionReason["NOT_INTERESTED"] = "NOT_INTERESTED";
    HlOnboardingRejectionReason["FAKE_USER"] = "FAKE_USER";
    HlOnboardingRejectionReason["SUSPICIOUS_USER"] = "SUSPICIOUS_USER";
    HlOnboardingRejectionReason["DUPLICATE"] = "DUPLICATE";
    HlOnboardingRejectionReason["OTHER"] = "OTHER";
})(HlOnboardingRejectionReason = exports.HlOnboardingRejectionReason || (exports.HlOnboardingRejectionReason = {}));
class HlUserOnboardingRejectionInfo extends BaseUserOnboardingRejectionInfo_1.BaseUserOnboardingRejectionInfo {
}
exports.HlUserOnboardingRejectionInfo = HlUserOnboardingRejectionInfo;
//# sourceMappingURL=HlUserOnboardingRejectionInfo.js.map